/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import ObjectType from './ObjectType';
import ActivationMode from './ActivationMode';
import CaseSensitivityMode from './CaseSensitivityMode';
import MoserObject from './MoserObject';
//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/ActivationMode (runtime) // new, ActivationMode
//@import com/ibm/bi/platform/moser/common/generated/metadata/CaseSensitivityMode (runtime) // new, CaseSensitivityMode
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper

/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="fromLocale" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="toLocale" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="activation" type="{}activationMode" minOccurs="0"/&gt; &lt;element name="fromRef" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="toRef" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="idRef" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="fromRefCaseSensitivity" type="{}caseSensitivityMode" minOccurs="0"/&gt; &lt;element name="idRefCaseSensitivity" type="{}caseSensitivityMode" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class Translation extends ObjectType{

	fromLocale = null;

	toLocale = null;

	activation = null;

	fromRef = null;

	toRef = null;

	idRef = null;

	fromRefCaseSensitivity = null;

	idRefCaseSensitivity = null;



	/**
	 * Gets the value of the fromLocale property.
	 * @return {String} possible object is {@link String}
	 */
	getFromLocale() {
		return this.fromLocale;
	}

	/**
	 * Sets the value of the fromLocale property.
	 * @param {String} value allowed object is {@link String}
	 */
	setFromLocale(value) {
		var oldValue = this.fromLocale;
		this.fromLocale = value;
		this._setAndNotify(226, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the toLocale property.
	 * @return {String} possible object is {@link String}
	 */
	getToLocale() {
		return this.toLocale;
	}

	/**
	 * Sets the value of the toLocale property.
	 * @param {String} value allowed object is {@link String}
	 */
	setToLocale(value) {
		var oldValue = this.toLocale;
		this.toLocale = value;
		this._setAndNotify(227, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the activation property.
	 * @return {ActivationMode} possible object is {@link ActivationMode}
	 */
	getActivation() {
		if (!this.activation) {
			return ActivationMode.ACTIVE;
		}
		return this.activation;
	}

	/**
	 * Sets the value of the activation property.
	 * @param {ActivationMode} value allowed object is {@link ActivationMode}
	 */
	setActivation(value) {
		var oldValue = this.activation;
		this.activation = value;
		this._setAndNotify(228, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the fromRef property.
	 * @return {String} possible object is {@link String}
	 */
	getFromRef() {
		return this.fromRef;
	}

	/**
	 * Sets the value of the fromRef property.
	 * @param {String} value allowed object is {@link String}
	 */
	setFromRef(value) {
		var oldValue = this.fromRef;
		this.fromRef = value;
		this._setAndNotify(229, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the toRef property.
	 * @return {String} possible object is {@link String}
	 */
	getToRef() {
		return this.toRef;
	}

	/**
	 * Sets the value of the toRef property.
	 * @param {String} value allowed object is {@link String}
	 */
	setToRef(value) {
		var oldValue = this.toRef;
		this.toRef = value;
		this._setAndNotify(230, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the idRef property.
	 * @return {String} possible object is {@link String}
	 */
	getIdRef() {
		return this.idRef;
	}

	/**
	 * Sets the value of the idRef property.
	 * @param {String} value allowed object is {@link String}
	 */
	setIdRef(value) {
		var oldValue = this.idRef;
		this.idRef = value;
		this._setAndNotify(231, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the fromRefCaseSensitivity property.
	 * @return {CaseSensitivityMode} possible object is {@link CaseSensitivityMode}
	 */
	getFromRefCaseSensitivity() {
		if (!this.fromRefCaseSensitivity) {
			return CaseSensitivityMode.CASE_INSENSITIVE;
		}
		return this.fromRefCaseSensitivity;
	}

	/**
	 * Sets the value of the fromRefCaseSensitivity property.
	 * @param {CaseSensitivityMode} value allowed object is {@link CaseSensitivityMode}
	 */
	setFromRefCaseSensitivity(value) {
		var oldValue = this.fromRefCaseSensitivity;
		this.fromRefCaseSensitivity = value;
		this._setAndNotify(232, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the idRefCaseSensitivity property.
	 * @return {CaseSensitivityMode} possible object is {@link CaseSensitivityMode}
	 */
	getIdRefCaseSensitivity() {
		if (!this.idRefCaseSensitivity) {
			return CaseSensitivityMode.CASE_INSENSITIVE;
		}
		return this.idRefCaseSensitivity;
	}

	/**
	 * Sets the value of the idRefCaseSensitivity property.
	 * @param {CaseSensitivityMode} value allowed object is {@link CaseSensitivityMode}
	 */
	setIdRefCaseSensitivity(value) {
		var oldValue = this.idRefCaseSensitivity;
		this.idRefCaseSensitivity = value;
		this._setAndNotify(233, oldValue, value, false, true);
	}

	/**
	 * Creates a new instance of <code>Translation</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> Translation</code> object from.
	 * @return {Translation} an object of type <code>Translation</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createTranslation();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "Translation";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 226, "fromLocale", null));
		featureList.push(this.createFeature(false, false, false, 227, "toLocale", null));
		featureList.push(this.createFeature(false, true, false, 228, "activation", ActivationMode));
		featureList.push(this.createFeature(false, false, false, 229, "fromRef", null));
		featureList.push(this.createFeature(false, false, false, 230, "toRef", null));
		featureList.push(this.createFeature(false, false, false, 231, "idRef", null));
		featureList.push(this.createFeature(false, true, false, 232, "fromRefCaseSensitivity", CaseSensitivityMode));
		featureList.push(this.createFeature(false, true, false, 233, "idRefCaseSensitivity", CaseSensitivityMode));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 226:
			this.setFromLocale((value));
			break;
		case 227:
			this.setToLocale((value));
			break;
		case 228:
			this.setActivation((value));
			break;
		case 229:
			this.setFromRef((value));
			break;
		case 230:
			this.setToRef((value));
			break;
		case 231:
			this.setIdRef((value));
			break;
		case 232:
			this.setFromRefCaseSensitivity((value));
			break;
		case 233:
			this.setIdRefCaseSensitivity((value));
			break;
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 226:
			return this.getFromLocale();
		case 227:
			return this.getToLocale();
		case 228:
			return this.getActivation();
		case 229:
			return this.getFromRef();
		case 230:
			return this.getToRef();
		case 231:
			return this.getIdRef();
		case 232:
			return this.getFromRefCaseSensitivity();
		case 233:
			return this.getIdRefCaseSensitivity();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 226:
			return this.getFromLocale();
		case 227:
			return this.getToLocale();
		case 228:
			return this.getActivation();
		case 229:
			return this.getFromRef();
		case 230:
			return this.getToRef();
		case 231:
			return this.getIdRef();
		case 232:
			return this.getFromRefCaseSensitivity();
		case 233:
			return this.getIdRefCaseSensitivity();
		default:
			return super.basicGet(featureID);
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/Translation.js